export interface OrderItemApi {
    id: number;
    object_id: number;
    object_name_manual: string;
    object_name: string;
    employee_id: number;
    delievered_utc: number;
    created_utc: number;
    updated_utc: number;
}

export interface OrderItem {
    id: number;
    objectId: number;
    objectNameManual: string;
    objectName: string;
    employeeId: number;
    delieveredUtc: number;
    createdUtc: number;
    updatedUtc: number;
}

export interface OrderItemStatusInfo {
    label: string;
    chipColor: string;
    chipBgColor: string;
    cardBgColor: string;
    icon: string;
}

export function getOrderItemStatusInfo(orderItem: OrderItem): OrderItemStatusInfo {
    return getOrderItemStatusInfoBase(isOrderItemDelivered(orderItem));
}

export function getOrderItemStatusInfoBase(delivered: boolean): OrderItemStatusInfo {
    if (delivered) {
        return {
            label: 'Geliefert',
            chipColor: '#4CAF50',
            chipBgColor: '#E8F5E8',
            cardBgColor: '#f8fff8',
            icon: 'pi-truck',
        };
    } else {
        return {
            label: 'Nicht geliefert',
            chipColor: '#FF9800',
            chipBgColor: '#FFF3E0',
            cardBgColor: '#fffbf0',
            icon: 'pi-sync',
        };
    }
}

export function isOrderItemDelivered(orderItem: OrderItem): boolean {
    return orderItem.delieveredUtc !== null;
}
